import {
  doc,
  onSnapshot,
  FirestoreError,
  Unsubscribe,
} from "firebase/firestore";
import { db } from "../../firebase";
import { EntityGet, EntityServerGet, OnSnapshotDocService } from "../../types";
import { Thread } from "./types";
import { transformMetadata, processTimestampFields } from "../../utils";

export type ThreadOnSnapshotDocService<T> = (
  agentId: string,
  id: string,
  callback: (doc: T) => void,
  onError?: (error: FirestoreError) => void
) => Unsubscribe;

const onSnapshotDoc: ThreadOnSnapshotDocService<EntityGet<Thread>> = (
  agentId,
  id,
  callback,
  onError
) => {
  const docRef = doc(db, `/agent/${agentId}/thread/${id}`);
  return onSnapshot(
    docRef,
    (docSnap) => {
      if (docSnap.exists()) {
        callback(
          processTimestampFields(
            transformMetadata(
              {
                ...docSnap.data(),
                id: docSnap.id,
              } as EntityServerGet<Thread>,
              docSnap.metadata
            )
          ) as EntityGet<Thread>
        );
      } else {
        onError?.({
          name: "FirestoreError",
          code: "not-found",
          message: `Document "${id}" was not found`,
        });
      }
    },
    onError
  );
};

export default onSnapshotDoc;
